import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import OutlineVerticalAlignBottom from 'react-md-icon/dist/OutlineVerticalAlignBottom';
import { FormattedMessage } from 'react-intl';

import './DownloadButton.scss';

const DownloadButton = ({
  downloadAction,
  classes,
  color,
  hidden,
  isDisabled,
  tabIndex,
  expandedButton,
  onClick,
}) => {
  const expandedClasses = new Set(['d-flex', 'align-items-center', 'btn-wrapper', 'btn-link']);
  const smallClasses = new Set(['btn-download']);
  if (isDisabled) {
    expandedClasses.add('btn-download-disabled');
    smallClasses.add('btn-download-disabled');
  } else {
    expandedClasses.add('btn-wrapper-enabled');
  }
  return (
    <Button
      color={color}
      className={`${classes.join(' ')} ${expandedButton ? Array.from(expandedClasses).join(' ') : Array.from(smallClasses).join(' ')}`}
      onClick={(e) => {
      if (onClick) {
        onClick(e);
      } else {
        e.stopPropagation();
        // using disabled={isDisabled} will prevent the hover effect AND the stopPropogation,
        // both of which we want, so instead we can just disable the onClick
        if (!isDisabled) downloadAction();
      }
    }}
      hidden={hidden}
      tabIndex={isDisabled ? '-1' : tabIndex}
    >
      <OutlineVerticalAlignBottom style={{ fontSize: '1.5rem', lineHeight: 1 }} />
      {expandedButton ?
        <div className={`header-text float-right pl-2 ${isDisabled ? 'disabled-text' : ''}`}>
          <FormattedMessage id="DOWNLOAD" />
        </div> :
      null}
    </Button>);
};

DownloadButton.defaultProps = {
  classes: [],
  color: '',
  hidden: false,
  isDisabled: false,
  tabIndex: '0',
  expandedButton: false,
  onClick: null,
  downloadAction: () => {},
};

DownloadButton.propTypes = {
  downloadAction: PropTypes.func,
  classes: PropTypes.arrayOf(PropTypes.string),
  color: PropTypes.string,
  hidden: PropTypes.bool,
  isDisabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  expandedButton: PropTypes.bool,
  onClick: PropTypes.func,
};

export default DownloadButton;



// WEBPACK FOOTER //
// ./src/components/DownloadButton/DownloadButton.jsx